import React, { useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import './LoginPage.css';
import JoinAuth from '../components/JoinAuth';
import useAuth from '../hooks/useAuth';

// Only allow same-origin absolute paths as a post-login destination (blocks
// open-redirects like //evil.com or https://…).
function safeNext(raw) {
  return raw && /^\/(?!\/)/.test(raw) ? raw : '/';
}

// Standalone sign-in / sign-up page. Hosts the shared JoinAuth flows (email +
// password, email link, Google, MFA) — the only place the app authenticates.
// Emailed sign-in links return here, so JoinAuth completes them on mount. Once
// signed in,
// it sends the user straight to `?next=<path>` (the page they were headed to),
// defaulting to home.
export default function LoginPage() {
  const user = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = safeNext(params.get('next'));

  useEffect(() => {
    if (user) navigate(next, { replace: true });
  }, [user, next, navigate]);

  return (
    <div className="login-page">
      <div className="login-inner">
        <Link to="/" className="login-brand" aria-label="Dutchess County Bhabani home">
          <img src="/images/logo.png" alt="Dutchess County Bhabani" className="login-logo" />
        </Link>
        {user ? (
          <p className="login-redirecting">Signing you in…</p>
        ) : (
          <JoinAuth />
        )}
      </div>
    </div>
  );
}
